var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.409,
    height: 27.409,
    viewBox: "0 0 27.409 27.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#016fd0;}.a,.b{fill-rule:evenodd;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M472,1128h27.409v27.409H472V1128Z",
    transform: "translate(-472 -1128)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M506.942,1229.473v-4.3H511.5l.489.637.5-.637h16.538v4.006a1.909,1.909,0,0,1-.933.3H518.94l-.551-.678v.678h-1.806v-1.158a1.515,1.515,0,0,1-.78.162h-.615v1h-2.735l-.488-.651-.5.651Z",
    transform: "translate(-501.621 -1210.374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M472,1190.534l1.028-2.4H474.8l.583,1.342v-1.342H477.6l.347.97.337-.97H488.2v.488a2.139,2.139,0,0,1,1.378-.488l3.217.011.573,1.324v-1.335h1.848l.509.761v-.761h1.866v4.3h-1.866l-.488-.763v.763h-2.716l-.273-.678h-.73l-.269.678H489.4a1.821,1.821,0,0,1-1.208-.478v.478h-2.777l-.551-.678v.678H474.541l-.273-.678h-.728l-.271.678H472v-1.908Z",
    transform: "translate(-472 -1178.982)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M473.421,1191.623l-1.386,3.222h.9l.256-.645h1.487l.254.645h.922l-1.384-3.222Zm.513.75.453,1.127h-.908l.454-1.127Z",
    transform: "translate(-472.03 -1181.935)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M497.754,1194.842v-3.222l1.282,0,.746,2.078.728-2.082h1.272v3.222h-.805v-2.374l-.854,2.374h-.706l-.856-2.374v2.374Z",
    transform: "translate(-493.832 -1181.932)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M527.824,1194.842v-3.222h2.629v.721h-1.815v.551h1.772v.678h-1.772v.572h1.815v.7Z",
    transform: "translate(-519.324 -1181.932)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M548.149,1191.623v3.222h.805V1193.7h.339l.966,1.145h.984l-1.06-1.187a.981.981,0,0,0,.884-.99,1.042,1.042,0,0,0-1.126-1.045Zm.805.721h.921a.37.37,0,0,1,.381.339.364.364,0,0,1-.37.339h-.933v-.678Z",
    transform: "translate(-536.553 -1181.935)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M570.3,1194.842h-.823v-3.222h.823v3.222Z",
    transform: "translate(-554.633 -1181.932)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M579.01,1194.842h-.178a1.42,1.42,0,0,1-1.381-1.6,1.476,1.476,0,0,1,1.6-1.624h.89v.763h-.923a.775.775,0,0,0-.752.869.789.789,0,0,0,.869.886h.212l-.339.7Z",
    transform: "translate(-561.394 -1181.932)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M591.481,1191.623l-1.386,3.222h.9l.256-.645h1.487l.255.645h.922l-1.385-3.222Zm.513.75.453,1.127h-.908l.454-1.127Z",
    transform: "translate(-572.112 -1181.935)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M615.805,1194.842v-3.222h1.024l1.308,2.025v-2.025h.806v3.222h-.991l-1.341-2.077v2.077Z",
    transform: "translate(-593.907 -1181.932)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M510.562,1231.872v-3.222h2.629v.721h-1.815v.551h1.772v.678h-1.772v.572h1.815v.7Z",
    transform: "translate(-504.69 -1213.323)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M595.146,1231.872v-3.222h2.629v.721H595.96v.551h1.764v.678H595.96v.572h1.815v.7Z",
    transform: "translate(-576.394 -1213.323)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M528.324,1231.872l1.28-1.591-1.31-1.631h1.015l.78,1.008.783-1.008h.975l-1.293,1.611,1.282,1.611h-1.015l-.758-.992-.739.992Z",
    transform: "translate(-519.722 -1213.324)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M552.186,1228.653v3.222h.827v-1.018h.848a1.114,1.114,0,0,0,1.261-1.121,1.061,1.061,0,0,0-1.157-1.084Zm.827.729h.893a.364.364,0,0,1,.4.371.372.372,0,0,1-.4.371h-.89v-.742Z",
    transform: "translate(-539.976 -1213.326)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M573.763,1228.649v3.222h.805v-1.145h.339l.966,1.145h.984l-1.06-1.187a.981.981,0,0,0,.884-.99,1.042,1.042,0,0,0-1.126-1.045h-1.793Zm.805.721h.921a.37.37,0,0,1,.382.339.364.364,0,0,1-.37.339h-.933v-.678Z",
    transform: "translate(-558.267 -1213.323)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M614.289,1231.872v-.7H615.9c.239,0,.342-.129.342-.27s-.1-.273-.342-.273h-.728a.9.9,0,0,1-.986-.965c0-.517.323-1.015,1.264-1.015h1.569l-.339.725h-1.357c-.259,0-.339.136-.339.266a.281.281,0,0,0,.3.281h.763a.884.884,0,0,1,1.012.925.966.966,0,0,1-1.051,1.025Z",
    transform: "translate(-592.536 -1213.324)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M633.705,1231.872v-.7h1.544c.239,0,.342-.129.342-.27s-.1-.273-.342-.273h-.66a.9.9,0,0,1-.986-.965c0-.517.323-1.015,1.264-1.015H636.4l-.339.725H634.74c-.259,0-.339.136-.339.266a.281.281,0,0,0,.3.281h.695a.884.884,0,0,1,1.012.925.966.966,0,0,1-1.051,1.025Z",
    transform: "translate(-608.995 -1213.324)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.7170c59ee65797237084b5d37e81551d.svg";
export { ForwardRef as ReactComponent };